import React from "react";
import { Box } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * Tiny pill with leading dot + status label.
 * Falls back to "Pending" styling for unknown statuses.
 */
const StatusPill = ({ status }) => {
  const known = TOKENS.statuses[status];
  const style = known || TOKENS.statuses.Pending;
  const label = status || "Pending";
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        height: 24,
        px: "10px",
        borderRadius: 999,
        background: style.bg,
        color: style.ink,
        border: `1px solid ${style.border}`,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: style.dot,
          flexShrink: 0,
        }}
      />
      {label}
    </Box>
  );
};

export default StatusPill;
